import React from 'react';

import styles from './Skeleton.module.scss';

// A shimmering placeholder for content that is still loading, as the loading
// cards in the stamtavle
function Skeleton(props: SkeletonProps) {
    return (
        <span
            className={styles.skeleton + (props.circle ? " " + styles.circle : "") + (props.className ? " " + props.className : "")}
            style={{
                width: props.width ?? "100%",
                height: props.height ?? 12,
                ...(props.circle ? { width: props.height ?? 12 } : {}),
            }}
            aria-hidden="true"
        />
    );
}

class SkeletonProps {
    width?: number | string;
    height?: number | string;
    circle?: boolean;
    className?: string;
}

export default Skeleton;
